export default {
  plants: [],
}
